import React, { useState, FC } from 'react';
import {
  Box,
  Button
} from '@mui/material';
import { Typography700, Faq } from 'views/rebranded-module/common/components';
import StyledBox from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/FAQSSection/FAQSSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const FAQSSection: FC<any> = (props) => {
  const content = useContent('MembershipLandingPage');
  const {faqs} = props; 
  const minFAQs = 4;
  const [count, setCount] = useState(faqs.length > minFAQs ? minFAQs : faqs.length);
  const handleToggleFAQs = () => {
    setCount(count === faqs.length ? minFAQs : faqs.length);
  };

  //  generating  IDs for the FAQ items since they don't have
  const faqsWithIds = faqs.map((faq, index) => ({
    ...faq,
    id: `faq-${index}`
  }));

  return (
    <StyledBox>
        <Typography700 variant='h5' component="h2" mb={5}>
            {content.faqSectionTitle}
        </Typography700>
         <Faq data={faqsWithIds.slice(0, count)} />
             {faqs.length > minFAQs && (
            <Box mt={5}>
              <Button
                onClick={handleToggleFAQs}  
                variant="contained"
                color="primary"
                size="large"
                >
                {count === faqs.length ?  content.seeLessFAQsBtn :  content.seeAllFAQsBtn }
              </Button>
            </Box>
          )}
    </StyledBox>
  );
};
export { FAQSSection };